/**
 * The "StudyID=N" key of a peer-group criteria string, e.g. "StudyID=25" from
 * "StudyID=25;CarTruck=C;GroupID=273".
 *
 * Group pages match API rows by their full criteria ("<study>;CarTruck=C;GroupID=<id>"
 * for "Your Group", "<study>;CarTruck=C" for "All Dealerships"). The backend serves one
 * study per group, so the study comes from the rows themselves — never a hard-coded id,
 * which silently stops matching once the dashboard moves to the next study.
 */
export function studyKeyOf(criteria: string | null | undefined): string | undefined {
    return criteria?.match(/^StudyID=\d+/)?.[0];
}
